// Smart Sash Admin Panel - Main Layout Component
// Main application layout with header, sidebar, and content area

import React from 'react';
import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { Sidebar } from './Sidebar';
import { Footer } from './Footer';
import { useUIStore } from '@/store';

/**
 * Main Layout Component
 * Wraps all authenticated pages
 */
export const MainLayout: React.FC = () => {
  const { sidebarCollapsed, toggleSidebar } = useUIStore();

  return (
    <div className="d-flex flex-column min-vh-100">
      {/* Header */}
      <Header onToggleSidebar={toggleSidebar} />

      <div className="flex-grow-1 d-flex">
        {/* Sidebar */}
        <Sidebar collapsed={sidebarCollapsed} />

        {/* Main Content */}
        <main className="flex-grow-1 p-4 bg-light">
          <Outlet />
        </main>
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default MainLayout;
